export default "__VITE_ASSET__BcXLgoai__"